/**
 * Cached option lists for selects (properties, tenancies, owners, categories...).
 */
import type { Option } from "@shared/constants.ts";
import { useApi } from "./query.ts";

export interface LookupItem {
  id: string;
  label: string;
  [key: string]: unknown;
}

export interface Lookups {
  properties: Array<LookupItem & { status: string; propertyType: string }>;
  tenancies: Array<LookupItem & { propertyId: string; status: string }>;
  owners: Array<LookupItem & { ownerType: string; accountingBasis: string }>;
  tenants: LookupItem[];
  contractors: LookupItem[];
  categories: Array<LookupItem & { treatment: string; hmrcCategory: string | null; isArchived: boolean }>;
  complianceTypes: Array<LookupItem & { validityMonths: number | null; isArchived: boolean }>;
  members: LookupItem[];
}

export function useLookups() {
  const q = useApi<Lookups>("/api/lookups");
  return q.data;
}

export function toOptions(items: LookupItem[] | undefined, filter?: (i: LookupItem) => boolean): Option[] {
  return (items ?? []).filter(filter ?? (() => true)).map((i) => ({ value: i.id, label: i.label }));
}
